module.exports = __webpack_public_path__ + "img/pandemic-radio.a2393033.png";